import { SelectPicker } from "rsuite";
import { TypeTemplate, templateTypePicker } from "../../config";

interface IProps {
  handleChange: (value: TypeTemplate) => void;
}

export function TemplatePicker({ handleChange }: IProps) {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col col-md-6">
          <SelectPicker
            placeholder="Select Template Type"
            data={templateTypePicker}
            style={{ width: "100%" }}
            onChange={(value) => handleChange(value as TypeTemplate)}
          />
        </div>
      </div>
    </div>
  );
}
